(function ($) {
  'use strict';

  var MODAL_SELECTOR = '#northbound-community-modal';
  var SELECT_SELECTOR = '[data-northbound-community-select]';
  var APPLY_SELECTOR = '[data-northbound-community-apply]';
  var TRIGGER_SELECTOR = '[data-northbound-trigger]';
  var TRIGGER_LABEL_SELECTOR = '[data-northbound-trigger-label]';

  // Region label map. Syllabics intentionally omitted pending merchant
  // verification — see report. Roman labels match the contract regions.
  var REGION_LABELS = {
    QIKIQTAALUK: 'Qikiqtaaluk',
    KIVALLIQ: 'Kivalliq',
    KITIKMEOT: 'Kitikmeot',
  };

  var hasPopulated = false;

  function getStorefront() {
    return window.NorthboundStorefront || null;
  }

  function getCurrentSelection() {
    var sf = getStorefront();
    if (sf && typeof sf.getSelectedCommunity === 'function') {
      return sf.getSelectedCommunity();
    }
    return null;
  }

  function getCommunities() {
    var sf = getStorefront();
    if (!sf || typeof sf.getBootstrap !== 'function') return [];
    var bootstrap = sf.getBootstrap();
    if (!bootstrap || !Array.isArray(bootstrap.communities)) return [];
    return bootstrap.communities;
  }

  function regionLabel(region) {
    if (region && REGION_LABELS[region]) return REGION_LABELS[region];
    return 'Other';
  }

  function groupByRegion(communities) {
    var groups = {};
    var order = [];
    communities.forEach(function (c) {
      var key = c.region || 'OTHER';
      if (!groups[key]) {
        groups[key] = [];
        order.push(key);
      }
      groups[key].push(c);
    });
    return { order: order, groups: groups };
  }

  function populateSelect() {
    var $select = $(SELECT_SELECTOR);
    if (!$select.length) return;

    var communities = getCommunities();
    if (!communities.length) {
      $select.html('<option value="">No communities available</option>');
      return;
    }

    var current = getCurrentSelection();
    var currentKey = current ? current.communityKey : '';

    var grouped = groupByRegion(communities);
    var html = '<option value="">Select a community&hellip;</option>';

    grouped.order.forEach(function (region) {
      html += '<optgroup label="' + regionLabel(region) + '">';
      grouped.groups[region].forEach(function (c) {
        var selected = c.communityKey === currentKey ? ' selected' : '';
        html +=
          '<option value="' + c.communityKey + '"' + selected + '>' +
          c.name +
          '</option>';
      });
      html += '</optgroup>';
    });

    $select.html(html);
    hasPopulated = true;
  }

  function updateTriggerLabel() {
    var $labels = $(TRIGGER_LABEL_SELECTOR);
    if (!$labels.length) return;
    var current = getCurrentSelection();
    if (current && current.name) {
      $labels.text(current.name);
    } else {
      $labels.text('Choose location');
    }
  }

  function openModal() {
    if (!hasPopulated) populateSelect();
    $(MODAL_SELECTOR).modal('show');
  }

  function closeModal() {
    $(MODAL_SELECTOR).modal('hide');
  }

  function handleApply() {
    var key = $(SELECT_SELECTOR).val();
    if (!key) return;
    var sf = getStorefront();
    if (sf && typeof sf.setCommunity === 'function') {
      sf.setCommunity(key);
    }
    closeModal();
  }

  function bind() {
    $(document).on('click', TRIGGER_SELECTOR, function (e) {
      e.preventDefault();
      openModal();
    });

    $(document).on('click', APPLY_SELECTOR, function (e) {
      e.preventDefault();
      handleApply();
    });

    window.addEventListener('northbound:bootstrap-ready', function (e) {
      populateSelect();
      updateTriggerLabel();
      var detail = e && e.detail ? e.detail : {};
      var shouldAutoOpen = !!detail.shouldAutoOpenSelector;
      var hasSelection = !!document.documentElement.getAttribute(
        'data-northbound-community-key'
      );
      if (shouldAutoOpen && !hasSelection) {
        openModal();
      }
    });

    window.addEventListener('northbound:open-selector-requested', function () {
      openModal();
    });

    window.addEventListener('northbound:community-changed', function () {
      updateTriggerLabel();
      // Refresh selected option in case the modal opens again.
      if (hasPopulated) populateSelect();
    });
  }

  $(function () {
    bind();
    // If bootstrap data is already available at DOM ready, populate now.
    if (getCommunities().length) populateSelect();
    updateTriggerLabel();
  });
})(jQuery);
